import React from 'react';
import cx from 'classnames';
import { StreamingSvgTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';

export const Svg = React.forwardRef<
  SVGSVGElement,
  StreamingSvgTreeNodeData & { id: string; editorClassName?: string; isEditor?: boolean }
>(({ id, className, editorClassName, svg, viewBox = '0 0 24 24', isEditor: _isEditor, ...props }, ref) => {
  return (
    <svg
      id={id}
      ref={ref}
      className={cx(className, editorClassName)}
      viewBox={viewBox}
      dangerouslySetInnerHTML={{ __html: svg ?? '' }}
      {...props}
    />
  );
});

Svg.displayName = 'Svg';
